export function getDirtyValues<T>(dirtyFields: any, allValues: T): Partial<T> {
    if (!dirtyFields) return {};

    return Object.keys(dirtyFields).reduce((acc, key) => {
        const isDirty = dirtyFields[key];
        const value = (allValues as any)[key];

        if (isDirty === true) {
            acc[key] = value;
        } else if (typeof isDirty === 'object') {
            acc[key] = getDirtyValues(isDirty, value);
        }

        return acc;
    }, {} as any);
}
